<template>
  <div class="price-area">
    <slot name="short-button">
      <span v-if="displayAmount !== ''" class="before-price">
        &#65510;{{ setNumberComma(displayAmount) }}
      </span>
      <button
        :id="productId"
        ref="purchaseButton"
        type="button"
        class="btn"
        @click="$emit('on-click-purchase', { productid: productId })"
      >
        &#65510;{{ setNumberComma(amount) }}
      </button>
    </slot>
  </div>
</template>
<script setup>
  import { computed, defineProps, defineEmits } from 'vue'
  import { setNumberComma } from '@/common/util/set-number-comma'

  const props = defineProps({
    voucher: {
      type: Object,
      default: () => {},
      required: true,
    },
    voucherItem: {
      type: Object,
      default: () => {},
    },
  })
  defineEmits(['on-click-purchase'])

  const amount = computed(() => props.voucherItem?.amount ?? '')
  const displayAmount = computed(() => props.voucherItem?.displayamount ?? '')
  const productId = computed(() => props.voucherItem?.productid ?? '')
</script>
